import { render, staticRenderFns } from "./PaymentDetailTmp.vue?vue&type=template&id=6fc23301&scoped=true"
import script from "./PaymentDetailTmp.vue?vue&type=script&lang=js"
export * from "./PaymentDetailTmp.vue?vue&type=script&lang=js"
import style0 from "./PaymentDetailTmp.vue?vue&type=style&index=0&id=6fc23301&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc23301",
  null
  
)

export default component.exports